import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { setAuthToken } from "../auth/auth";
import SiteLayout from "../components/SiteLayout";


const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://pelaj-forever2025-production.up.railway.app/weddingAccess";

export default function AdminLogin() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE_URL}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const json = await res.json();

      if (!res.ok || json?.statusCode !== 200) {
        throw new Error(json?.description || "Login failed");
      }

      const token = json?.data?.token;
      const ttl = json?.data?.ttl;

      if (!token) throw new Error("No token returned from login");

      setAuthToken(token, ttl);
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      setError(err.message || "Unable to login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <SiteLayout>
        <div className="admin-page">
            <div className="admin-card">
                <h2 className="admin-title">Admin Login</h2>
                <p className="admin-subtitle">Sign in to check in guests</p>

                {error && <div className="admin-error">{error}</div>}

                <form onSubmit={onSubmit} className="admin-form">
                <label className="admin-label">
                    Email
                    <input
                    className="admin-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    placeholder="admin@email.com"
                    required
                    />
                </label>

                <label className="admin-label">
                    Password
                    <input
                    className="admin-input"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    type="password"
                    placeholder="********"
                    required
                    />
                </label>

                <button className="admin-btn primary" disabled={loading} type="submit">
                    {loading ? "Signing in..." : "Login"}
                </button>
                </form>
            </div>
        </div>
    </SiteLayout>
  );
}
